import { CV } from "@/data/cv";

export default function Education() {
  return (
    <section id="bildung" data-testid="education-section" className="py-24 md:py-32 border-b-2 border-black bg-[#0F0F0F] text-[#F4F4F0]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="font-mono-acc text-xs text-[#F4F4F0]/60 mb-4">// 04 — Bildung</p>
            <h2 className="font-display uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              Bil<span className="text-[#FF3B00]">dung.</span>
            </h2>
            <p className="mt-6 text-sm md:text-base text-[#F4F4F0]/70 max-w-sm">
              Akademischer Background mit internationalem Fokus, abgeschlossen an der Europa-Universität Viadrina.
            </p>
          </div>
          <div className="md:col-span-8">
            <div className="grid gap-5">
              {CV.education.map((e, i) => (
                <article
                  key={i}
                  data-testid={`education-item-${i}`}
                  className="border-2 border-[#F4F4F0]/40 p-6 md:p-8 hover:border-[#FF3B00] transition-colors"
                >
                  <div className="flex flex-wrap items-baseline justify-between gap-3">
                    <h3 className="font-display uppercase text-xl md:text-2xl">{e.institution}</h3>
                    <span className="font-mono-acc text-[11px] md:text-xs text-[#F4F4F0]/70">{e.period}</span>
                  </div>
                  <p className="mt-2 text-sm md:text-base">{e.title}</p>
                  {e.note && (
                    <p className="mt-2 font-mono-acc text-[11px] text-[#F4F4F0]/80">{e.note}</p>
                  )}
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
